import React from "react"
import HomeCards from "./HomeCards"
import { graphql, useStaticQuery } from "gatsby"

function HomeCardsContainer() {
  const data = useStaticQuery(graphql`
    query BlogIndexQuery {
      allMarkdownRemark(
        sort: { fields: frontmatter___order, order: ASC }
        filter: { frontmatter: { type: { eq: "category" } } }
      ) {
        edges {
          node {
            id
            excerpt
            frontmatter {
              title
              slug
              bgImg
            }
          }
        }
      }
    }
  `)

  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-8 mx-auto">
          <h2 className="text-center text-danger display-3">Category</h2>
          <div className="row my-3 my-md-5">
            {data &&
              data.allMarkdownRemark.edges.map(({ node }) => (
                <HomeCards
                  key={node.id}
                  title={node.frontmatter.title}
                  excerpt={node.excerpt}
                  slug={node.frontmatter.slug}
                  posts={node.frontmatter.posts}
                  bgImg={node.frontmatter.bgImg}
                />
              ))}
          </div>
          <h1 className="text-center text-danger">And many more to come...</h1>
        </div>
      </div>
    </div>
  )
}

export default HomeCardsContainer
